import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AlertService, AlertConfig } from '../../services/alert.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-alert-container',
  standalone: true,
  imports: [CommonModule, AlertDialogComponent],
  template: `
    <app-alert-dialog
      [isOpen]="currentAlert !== null"
      [type]="currentAlert?.type || 'error'"
      [title]="currentAlert?.title"
      [message]="currentAlert?.message || ''"
      [details]="currentAlert?.details"
      [buttonText]="currentAlert?.buttonText"
      [confirmText]="currentAlert?.confirmText"
      [cancelText]="currentAlert?.cancelText"
      [showCopyButton]="currentAlert?.showCopyButton || false"
      [copyData]="currentAlert?.copyData"
      [copyLabel]="currentAlert?.copyLabel"
      [alertId]="currentAlert?.id"
      [actionButton]="currentAlert?.actionButton"
      (closed)="onAlertClosed()"
      (confirmed)="onAlertConfirmed()"
      (cancelled)="onAlertCancelled()"
      (copied)="onAlertCopied()"
    ></app-alert-dialog>
  `
})
export class AlertContainerComponent implements OnInit, OnDestroy {
  currentAlert: AlertConfig | null = null;
  private subscription: Subscription = new Subscription();

  constructor(private alertService: AlertService) {}

  ngOnInit(): void {
    this.subscription = this.alertService.alert$.subscribe(alert => {
      this.currentAlert = alert;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onAlertClosed(): void {
    this.alertService.close();
  }

  onAlertConfirmed(): void {
    // Action is handled by the alert dialog component
  }

  onAlertCancelled(): void {
    // Action is handled by the alert dialog component
  }

  onAlertCopied(): void {
    // Action is handled by the alert dialog component
  }
}